"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FooterLinks_1 = require("./FooterLinks");
exports.default = FooterLinks_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/FooterLinks/index.js
// module id = 555
// module chunks = 8